import React from 'react';
import { BookOpen, Sparkles, Award, Moon } from 'lucide-react';
import { motion } from 'framer-motion';
const trainings = [{
  icon: BookOpen,
  text: 'Entrenada con maestros en lectura de patrones kármicos'
}, {
  icon: Sparkles,
  text: 'Estudié sanación tradicional ancestral para limpieza de patrones'
}, {
  icon: Award,
  text: 'Certificada en múltiples modalidades de sanación energética'
}, {
  icon: Moon,
  text: 'Estudio profundo de astrología védica y timing para amor y relaciones'
}];
export function TrainingSection() {
  return <section className="w-full py-16 px-4 bg-[#0a0a0a]" data-id="element-306">
      <div className="max-w-6xl mx-auto" data-id="element-307">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8" data-id="element-308">
          {trainings.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-309">
              <div className="w-16 h-16 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-[#D4AF37] mb-6" data-id="element-310">
                <item.icon className="w-7 h-7" strokeWidth={1.5} data-id="element-311" />
              </div>
              <p className="font-inter text-gray-300 text-sm leading-relaxed" data-id="element-312">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}